import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export interface Props {
  expanded: boolean,
  onClick: (arg?: any) => void,
}

// A simple +/- expansion toggle for relationship lists
export default function ExpansionToggle({ expanded, onClick }: Props) {
  return (
    <button className="button--link button--link-inverse" onClick={onClick} type="button">
      <span className="fa fa-stack">
        <i className="fa fa-stack-2x fa-circle" />
        <i
          className={classnames(
            'fa fa-stack-1x fa-inverse',
            expanded ? 'fa-minus' : 'fa-plus',
          )}
        />
      </span>
    </button>
  );
}

ExpansionToggle.propTypes = {
  expanded: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};